import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Store } from "lucide-react";
import { timeAgo } from "@/lib/format";
import { formatDealPrice } from "@/lib/dealPrice";

const FALLBACK = "https://images.unsplash.com/photo-1607435097405-db48f377bff6?auto=format&fit=crop&w=800&q=60";

/** Deal grid card — used on /deals and the "More deals you may like" rail. */
export function DealCard({ deal }) {
  const img = deal.images?.[0] || FALLBACK;
  const fmt = formatDealPrice(deal);
  return (
    <Link to={`/deals/${deal.id}`} data-testid={`deal-card-${deal.id}`} className="group block bg-white rounded-xl shadow-card hover:shadow-card-hover overflow-hidden card-lift">
      <div className="relative aspect-[4/3] bg-slate-100">
        <img src={img} alt={deal.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        {deal.is_featured && <span className="ribbon">Featured</span>}
      </div>
      <div className="p-4 space-y-1.5">
        <div className="flex items-center justify-between text-[11px] text-slate-500">
          <span className="clamp-1"><MapPin className="w-3 h-3 inline mr-1" />{deal.city || deal.region || "New Zealand"}</span>
          <span>{timeAgo(deal.created_at)}</span>
        </div>
        <h3 className="font-display font-bold text-slate-900 text-[15px] leading-snug clamp-2 min-h-[2.6rem] group-hover:text-[color:var(--brand-blue)] transition-colors">{deal.title}</h3>
        {deal.posted_by && (
          <div className="inline-flex items-center gap-1 text-[12px] text-slate-500" data-testid={`deal-card-posted-by-${deal.id}`}>
            <Store className="w-3 h-3 text-slate-400" /> {deal.posted_by}
          </div>
        )}
        {fmt.payLine ? (
          <div className="pt-1 text-[13px] font-semibold text-slate-800 leading-snug" data-testid={`deal-card-pay-line-${deal.id}`}>
            {fmt.payLine}
          </div>
        ) : (
          <div className="pt-1 text-[13px] text-slate-500" data-testid={`deal-card-pay-line-${deal.id}`}>Contact for price</div>
        )}
      </div>
    </Link>
  );
}
